/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserManagementListUserResponse } from "./UserManagementListUserResponse";

export type UserManagementListUserResponseApiRespoonse = {
  data?: UserManagementListUserResponse;
  status?: UserManagementListUserResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace UserManagementListUserResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
